<ng-container>
  <div class="modal-header">
    <h5 class="modal-title">You are requesting access to &ldquo;{{ dashboardName }}&rdquo;</h5>
    <button type="button" class="close" aria-label="Close" (click)="onClose()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

  <div class="modal-body">
    <p class="mb-3">
      &ldquo;I am authorised to access this dashboard and understand Altius may verify my eligibility with {{ companyName }}&rdquo;
    </p>
    <div class="form-check">
      <input id="agreeCheck" type="checkbox" class="form-check-input" [(ngModel)]="agreed" />
      <label class="form-check-label" for="agreeCheck">I agree</label>
    </div>
  </div>

  <div class="modal-footer border-0 pt-0">
    <p *ngIf="errorMessage" class="text-danger small mb-2 w-100">{{ errorMessage }}</p>
    <button
      type="button"
      class="btn btn-primary"
      [disabled]="!agreed || submitting"
      (click)="onConfirm()">
      {{ submitting ? 'Submitting...' : 'REQUEST ACCESS' }}
    </button>
  </div>
</ng-container>
